import styled, { css } from 'styled-components';
import { FlexDiv } from '@shared/components/base/Div';
import { Image } from '@shared/components/base/Image';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import { Text } from '@shared/components/base/Text';
import ColorConstants from '@shared/constants/ColorConstants';
import { NO_TRANSLATE_CLASSNAME } from '@shared/components/no-translate/translation.constants';
import { Option } from '@shared/components/base/List';

export const StyledImage = styled(Image)`
    height: 24px;
    width: 24px;
`;

export const Title = styled(Text).attrs({
    className: NO_TRANSLATE_CLASSNAME,
})`
    font-size: 12px;
    font: Helvetica;
    font-weight: normal;
    line-height: 16px;
    text-align: center;
    color: ${ColorConstants['black-50%']};
`;

export const Subtitle = styled(Text)`
    color: ${ColorConstants['black-25%']};
    font: Helvetica;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    X constraint: Center
    Y constraint: Top

    svg {
        position: relative;
        top: 3;
    }
`;

export const ImageWrapper = styled(FlexDiv)`
    align-items: center;
    border-radius: 10px;
    height: 44px;
    justify-content: center;
    margin-bottom: 5px;
    width: 48px;
    background-color: ${ColorConstants.white};

    ${({ isDisabled }) => isDisabled && css`
        background-color: ${ColorConstants.white};
        opacity: 0.5;
    `}
`;

export const Item = styled(Option)`
    align-items: center;
    background-color: ${ColorConstants.GRAY_3};
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 121px;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0px 8px 8px 0px;
    padding: 8px;
    width: 115px;  
    box-shadow: 0px 4px 4px 0px #0000001A;

    &:hover {
        opacity: 0.8;
    }

    @media ${MobileScreen} {
        margin-bottom: 10px;
    }

    ${({ isDisabled }) => isDisabled && css`
        cursor: default;
        opacity: 0.5;
        &:hover {
        opacity: 0.5;
        }
    `}
    `;
